import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ContactUs } from "../../components/ContactUs/ContactUs";
import { DetailedResultsExpert } from "../../components/DetailedResults/DetailedResultsExpert";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import {
  ContactUsComponentWrapper,
  ContactUsComponentContentWrapper,
  ContactUsPageDesktopRightWrapper,
  ContactUsGeneralContainer,
  ContactUsPageWrapper,
  ContactUsBackTo,
} from "./ContactUsPage.styles";
import { ChatWidget } from "./ChatWidget";
import { TalkdeskChatWidget } from "../../components/TalkdeskChatWidget/TalkdeskChatWidget";
import { BackIcon } from "../../assets/iconComponents/BackIcon";
import { HELP_PAGE_URL } from "../../utils/urlConstants";
import { useVariantFeatureFlag } from "../../utils/hooks/useFeatureFlag";
import { FeatureFlags } from "../../utils/launchDarklyUtils";

const ContactUsPage = (): React.ReactElement => {
  const { deviceType } = useDeviceHook();
  const { t } = useTranslation();
  const history = useHistory();
  const { variant: chatbotVariant } = useVariantFeatureFlag(
    FeatureFlags.PatientPortalChatbot,
  );

  if (deviceType === "desktop") {
    return (
      <ContactUsPageWrapper>
        {chatbotVariant === "dialpad" && <ChatWidget />}
        {chatbotVariant === "talkdesk" && <TalkdeskChatWidget />}
        <ContactUsComponentWrapper deviceType={deviceType}>
          <ContactUsComponentContentWrapper deviceType={deviceType}>
            <ContactUsBackTo onClick={() => history.push(HELP_PAGE_URL)}>
              <BackIcon />
              {GetTypographyContent({
                content: t("contactUs.backToHelp"),
                size: "medium",
                textColor: "redMedium",
              })}
            </ContactUsBackTo>
            {GetTypographyContent({
              content: t("contactUs.title"),
              size: "h2",
              textColor: "greyMedium",
              isBold: true,
              padding: "10px 0 0 0",
            })}
            <ContactUsGeneralContainer padding="20px">
              <ContactUs />
            </ContactUsGeneralContainer>
          </ContactUsComponentContentWrapper>
          <ContactUsPageDesktopRightWrapper deviceType={deviceType}>
            {GetTypographyContent({
              content: t("contactUs.connect"),
              size: "medium",
              textColor: "greyMedium",
              isBold: true,
              className: "contact-us-connect",
            })}
            <ContactUsGeneralContainer padding="20px 20px 35px 20px">
              <DetailedResultsExpert contactUs />
            </ContactUsGeneralContainer>
          </ContactUsPageDesktopRightWrapper>
        </ContactUsComponentWrapper>
      </ContactUsPageWrapper>
    );
  }
  return (
    <ContactUsPageWrapper>
      {chatbotVariant === "dialpad" && <ChatWidget />}
      {chatbotVariant === "talkdesk" && <TalkdeskChatWidget />}
      <ContactUsComponentWrapper deviceType={deviceType}>
        <ContactUsComponentContentWrapper deviceType={deviceType}>
          <ContactUsBackTo onClick={() => history.push(HELP_PAGE_URL)}>
            <BackIcon />
            {GetTypographyContent({
              content: t("contactUs.backToHelp"),
              size: "medium",
              textColor: "redMedium",
            })}
          </ContactUsBackTo>
          {GetTypographyContent({
            content: t("contactUs.title"),
            size: "h2",
            textColor: "greyMedium",
            isBold: true,
            padding: deviceType === "mobile" ? "0 0 0 16px" : "",
          })}
          <ContactUsGeneralContainer padding="20px">
            <ContactUs />
          </ContactUsGeneralContainer>
          <ContactUsPageDesktopRightWrapper deviceType={deviceType}>
            {GetTypographyContent({
              content: t("contactUs.connect"),
              size: "large",
              textColor: "greyMedium",
              isBold: true,
              padding: "55px 0 28px 4px",
            })}
            <ContactUsGeneralContainer padding="30px 30px 35px 20px">
              <DetailedResultsExpert contactUs />
            </ContactUsGeneralContainer>
          </ContactUsPageDesktopRightWrapper>
        </ContactUsComponentContentWrapper>
      </ContactUsComponentWrapper>
    </ContactUsPageWrapper>
  );
};

export default ContactUsPage;
